import React, { useState, useEffect, useRef } from "react";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Table, Button, Input, Popconfirm, Card, Modal, message, Pagination } from "antd";
import { CheckOutlined, SearchOutlined } from "@ant-design/icons";
import DeleteIcon from "../../../../Images/deleteIcon.png";
import { Add_Update_Designation, Current_Designation, Get_Designation_Users_Count, Role_Account_Query } from "../../../../services/userAPI"; // Adjust path
import { useLocation, useNavigate } from "react-router-dom";
import GenderConfiguration from "./genderConfigurations";
import EmployementTypeConfiguration from "./employementType";
import "./mastersConfiguration.css";
import "./genderConfiguration.css";
import ThresholdsConfiguration from "./thresholdsConfiguration";
import AddPlusIcon from "../../../../Images/addplusIconWhite.png";
import UserManagement from "./userManagement/userManagement";
import PageBreadcrumb from '../../../../reusableField/PageBreadcrumb';
import ButtonAlignment from "./userManagement/buttonalignment";
import MarkHoliday from "../../markHoliday";
import AttendanceDailyNorm from "./productConfiguration/attendancedailyNorm";
import { X } from "lucide-react";
import BackIcon from "../../../../Images/backIcon.png";
import HomeIcon from "../../../../Images/homeIcon.png";
import Delete from "../../../../Images/deleteIcon.png";
import "../../../../components/userProfilePage.css";


const MastersConfiguration = () => {


    const navigate = useNavigate();
    const location = useLocation();

    const [searchTerm, setSearchTerm] = useState(""); // For search in Masters Configuration
    const [currentPage, setCurrentPage] = useState(1); // Pagination state
    const [pageSize, setPageSize] = useState(5); // Set page size to 5
    const [editingKey, setEditingKey] = useState(null); // For handling row edit
    const [editedName, setEditedName] = useState(""); // For storing edited name
    const [isModalVisible, setIsModalVisible] = useState(false); // Modal visibility
    const [newDesignation, setNewDesignation] = useState("");
    const [deleteId, setDeleteId] = useState(null);
    const inputRef = useRef(null);

    const [designationEntries, setDesignationEntries] = useState([{ name: "" }]);

    const handleBack = () => {
        navigate("/admin"); // This will navigate back to the previous page
    }

    const handleDiscardClick = () => {
        navigate("/admin");
    };


    // const getActiveTabFromPath = () => {
    //     if (location.pathname.includes("user-management")) return "user-management";
    //     return "masters-configuration";
    // };


    const [activeTab, setActiveTab] = useState("masters-configuration");
    const name = location.state?.name;
    const accountName = location.state?.accountName;
    const roleId = location.state?.roleId;
    const accountId = location.state?.accountId;
    const safeAccountName = accountName || "";
    const safeRoleName = name || currentRole?.name || "";
    const { data: roleData } = useQuery(Role_Account_Query, {
        variables: { accountId: accountId ? parseInt(accountId) : null },
        fetchPolicy: "network-only",
        skip: !accountId,
    });
    const currentRole = roleData?.getAllJobrole?.find((r) => r.id === roleId);


    const handleNextToProductConfiguration = () => {
        if (activeTab === "masters-configuration") {
            navigate("/user-management", { state: { roleId, accountId, name, accountName } });
        } else if (activeTab === "user-management") {
            navigate("/masterConfiguration", { state: { roleId, accountId, name, accountName } });
        }
    };

    const handleTabChange = (key) => {
        if (key === "masters-configuration") {
            navigate("/masterConfiguration", { state: { roleId, accountId, name, accountName } });
        } else if (key === "user-management") {
            navigate("/user-management", { state: { roleId, accountId, name, accountName } });
        } else if (key === "attendance-daily-norm") {
            navigate("/attendance-daily-norm", { state: { roleId, accountId, name, accountName } });
        } else if (key === "holidays") {
            navigate("/mark-holidays", { state: { roleId, accountId, name, accountName } });
        }
    };

    // Fetch data using GraphQL query
    const { loading, data, refetch } = useQuery(Current_Designation, {
        variables: {
            jobroleId: roleId,
            accountId: accountId,
        },
    });

    // Local state to store the fetched data
    const [fetchedData, setFetchedData] = useState([]);

    // UseEffect to store the fetched data in local state
    useEffect(() => {
        if (data) {
            const reversedData = [...(data?.getDesignationsJobroleid || [])].reverse();
            setFetchedData(reversedData);
        }
    }, [data]);

    useEffect(() => {
        if (isModalVisible && inputRef.current) {
            setTimeout(() => {
                inputRef.current.focus();
            }, 100);
        }
    }, [isModalVisible]);

    // Filter data based on search term
    const filteredData = fetchedData.filter((item) =>
        item.designation.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Paginate the filtered data
    const paginatedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when search term changes
    };

    const handleNextPage = () => {
        setCurrentPage((prev) => prev + 1);
    };

    const handlePreviousPage = () => {
        setCurrentPage((prev) => prev - 1);
    };

    const handleSave = (key) => {
        setEditingKey(null); // Reset the editing state
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setDesignationEntries([{ name: "" }]);
    };

    const [addUpdateDesignation, { loading: addLoading }] = useMutation(Add_Update_Designation);
    const [checkDesignationCount] = useLazyQuery(Get_Designation_Users_Count, { fetchPolicy: "network-only" });

    const handleAddDesignation = async () => {
        const trimmedEntries = designationEntries.map(d => d.name.trim());

        if (trimmedEntries.some(name => name === "")) {
            message.error("Please enter designation name");
            return;
        }

        if (!accountId || !roleId) {
            message.error("Something went wrong. Please refresh.");
            console.error("❌ Missing:", { accountId, roleId });
            return;
        }

        try {
            for (let name of trimmedEntries) {
                const response = await addUpdateDesignation({
                    variables: {
                        accountId: Number(accountId),
                        jobroleId: Number(roleId),
                        designationName: name,
                        designationId: null,
                    },
                    refetchQueries: [{ query: Current_Designation }],
                });

                if (!response?.data?.addUpdateDesignations?.success) {
                    message.error(
                        response?.data?.addUpdateDesignations?.message || "Failed to add designation"
                    );
                    return;
                }
            }

            message.success("Added successfully");
            setIsModalVisible(false);
            setDesignationEntries([{ name: "" }]);
            refetch();

        } catch (error) {
            console.error("🔥 ERROR:", error);
            message.error("Failed to add designation");
        }
    };
    const handleAddNewField = () => {
        setDesignationEntries([
            ...designationEntries,
            { name: "" }
        ]);
    };


    const handleDelete = async (designationId, designationName) => {
        setDeleteId(designationId);
        try {
            const countResponse = await checkDesignationCount({
                variables: {
                    accountId: accountId,
                    jobroleId: roleId,
                    designationId: designationId,
                },
            });
            const count = countResponse?.data?.getDesignationUsersCount ?? 0;
            if (count > 0) {
                message.error(`Cannot delete: ${count} user(s) are assigned to this designation.`);
                setDeleteId(null);
                return;
            }

            const response = await addUpdateDesignation({
                variables: {
                    accountId: Number(accountId),
                    jobroleId: Number(roleId),
                    designationName: designationName,
                    designationId: designationId,
                    status: 0,
                },
            });

            if (response.data.addUpdateDesignations.success) {
                message.success("Designation deleted successfully!");
                refetch();
            } else {
                message.error("Error: " + response.data.addUpdateDesignations.message);
            }
        } catch (error) {
            message.error("Failed to delete designation");
        } finally {
            setDeleteId(null);
        }
    };

    const columns = [
        {
            title: "Designation",
            dataIndex: "designation",
            key: "designation",
            render: (text, record) =>
                editingKey === record.key ? (
                    <Input
                        value={editedName}
                        onChange={(e) => setEditedName(e.target.value)}
                        onPressEnter={() => handleSave(record.key)}
                    />
                ) : (
                    text
                ),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", width: "100%" }}>
                    {editingKey === record.key ? (
                        <Button
                            type="primary"
                            icon={<CheckOutlined />}
                            onClick={() => handleSave(record.key)}
                            style={{ marginRight: 8 }}
                        />
                    ) : (
                        <Popconfirm
                            title="Are you sure you want to delete this?"
                            placement="leftTop"
                            overlayClassName="custom-delete-popconfirm"
                            onConfirm={() => handleDelete(record.id, record.designation)}
                            okText={deleteId === record.id ? " " : "Yes"}
                            cancelText="No"
                            okButtonProps={{
                                loading: deleteId === record.id,
                                style: {
                                    backgroundColor: "#AD0101",
                                    color: "#fff",
                                    width: "80px",
                                    height: "40px",
                                    border: "none",
                                    borderRadius: "10px",
                                    marginRight: "35px",
                                },
                            }}
                            cancelButtonProps={{
                                style: {
                                    backgroundColor: "#fff",
                                    color: "black",
                                    width: "80px",
                                    height: "40px",
                                    border: "1px solid black",
                                    borderRadius: "10px",
                                },
                            }}
                        >
                            <img src={DeleteIcon} alt="Delete" style={{ cursor: "pointer", width: "18px", height: "18px" }} />
                        </Popconfirm>
                    )}
                </div>
            ),
            align: "right",
        },
    ];


    const dartsFormNeeded = location.state?.dartsFormNeeded;
    const pocName = location.state?.pocName;
    const pocEmail = location.state?.pocEmail;
    const pocNumber = location.state?.pocNumber;
    const numberLogin = location.state?.numberLogin;
    const emailLogin = location.state?.emailLogin;
    const mandatoryTimeDistribution = location.state?.mandatoryTimeDistribution;
    const targetEditDays = location.state?.targetEditDays;
    const inputEditDays = location.state?.inputEditDays;
    const dartsNeeded = location.state?.dartsNeeded;
    const clanNeeded = location.state?.clanNeeded;
    const syncNeeded = location.state?.syncNeeded;

    const handleBackToViewRole = () => {
        const safeRoleId = roleId || location.state?.roleId;
        const safeAccountName = accountName || location.state?.accountName;

        navigate('/experience-configuration', {
            state: {
                roleId: safeRoleId,
                accountId: accountId || location.state?.accountId,
                accountName: safeAccountName,
                name: name || location.state?.name,
                dartsNeeded: dartsNeeded || location.state?.dartsNeeded,
                clanNeeded: clanNeeded || location.state?.clanNeeded,
                syncNeeded: syncNeeded || location.state?.syncNeeded,
                dartsFormNeeded: dartsFormNeeded || location.state?.dartsFormNeeded,
                pocName: pocName || location.state?.pocName,
                pocEmail: pocEmail || location.state?.pocEmail,
                pocNumber: pocNumber || location.state?.pocNumber,
                numberLogin: numberLogin || location.state?.numberLogin,
                emailLogin: emailLogin || location.state?.emailLogin,
                mandatoryTimeDistribution:
                    mandatoryTimeDistribution || location.state?.mandatoryTimeDistribution,
                targetEditDays: targetEditDays || location.state?.targetEditDays,
                inputEditDays: inputEditDays || location.state?.inputEditDays,
            },
        });
    };
    const handleDeleteDesignation = (indexToDelete) => {
        setDesignationEntries((prevEntries) =>
            prevEntries.filter((_, index) => index !== indexToDelete)
        );
    };

    return (
        <div className="user-profile-container">
            <div className="px-3">
                <div className="flex justify-between items-center w-full mx-2 ">

                    {/* Back Button */}
                    <button
                        onClick={handleBackToViewRole}
                        className="flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
                    >
                        <img
                            src={BackIcon}
                            alt="Back"
                            className="w-[15px] h-[15px] object-contain"
                        />
                        Back
                    </button>

                    {/* Home Button */}
                    <button
                        onClick={() => navigate("/admin")}
                        className="flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 mr-4 rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
                    >
                        <img
                            src={HomeIcon}
                            alt="Home"
                            className="w-[15px] h-[15px] object-contain"
                        />
                        Home
                    </button>

                </div>

                <div
                    className="flex items-center text-sm text-[#939393]"
                    style={{ marginTop: 13, marginLeft: 12 }}
                >
                    <span
                        onClick={() => navigate("/admin")}
                        className="cursor-pointer"
                    >
                        {safeAccountName}
                    </span>

                    <span className="mx-2 text-[14px]">›</span>

                    <span
                        onClick={() =>
                            navigate("/admin", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                },
                            })
                        }
                        className="cursor-pointer"
                    >
                        {safeRoleName}
                    </span>

                    <span className="mx-2 text-[14px]">›</span>

                    {/* Role Name */}

                    <span
                        onClick={() =>
                            navigate("/experience-configuration", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                },
                            })
                        }
                        className="cursor-pointer"
                    >
                        Experience Configuration
                    </span>

                    <span className="mx-2 text-[14px]">›</span>

                    <span className="font-semibold text-gray-800">
                        Masters Configuration
                    </span>
                </div>
                <ButtonAlignment
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    onTabChange={handleTabChange}
                    roleId={roleId}
                    accountId={accountId}
                    name={name}
                    accountName={accountName}
                />


                {activeTab === "masters-configuration" && (
                    <>
                        <Card
                            className="search-card"
                            bodyStyle={{
                                padding: "16px"
                            }}
                        >
                            <label
                                style={{
                                    fontFamily: "Inter",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    lineHeight: "100%",
                                    letterSpacing: "-1%",
                                    marginBottom: "2%",
                                }}
                            >
                                Designations
                            </label>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "20px",
                                    borderBottom: "none",
                                    marginTop: "8px",
                                }}
                            >
                                <div className="search-group" style={{ flex: 1 }}>
                                    <div className="search-input-wrapper">
                                        <Input
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            placeholder="Search designation"
                                            className="search-input-masters-configuration"
                                            suffix={<SearchOutlined />}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setIsModalVisible(true);
                                        }}
                                        className="add-designation-btn"
                                    >
                                        Add Designation
                                    </button>
                                </div>
                            </div>
                            <br />
                            <Table
                                columns={columns}
                                dataSource={paginatedData.map((item, index) => ({
                                    ...item,
                                    key: index,
                                }))}
                                pagination={false}
                                loading={loading}
                                showHeader={false}
                            />
                            {filteredData.length > pageSize && (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                                    <Pagination
                                        current={currentPage}
                                        pageSize={pageSize}
                                        total={filteredData.length}
                                        onChange={(page, size) => {
                                            setCurrentPage(page);
                                            setPageSize(size);
                                        }}
                                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                    />
                                </div>
                            )}
                        </Card>

                        {isModalVisible && (
                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">


                                <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
                                    <div className="flex items-center justify-between mb-4">
                                        <h3 className="text-lg font-semibold text-gray-800">Add Designation</h3>
                                        <button
                                            type="button"
                                            onClick={handleCancel}
                                            className="text-gray-400 hover:text-gray-600 transition-colors"
                                        >
                                            <X size={20} />
                                        </button>
                                    </div>
                                    {designationEntries.map((entry, index) => (
                                        <div
                                            key={index}
                                            className="relative w-full mb-3"
                                        >
                                            <input
                                                ref={index === 0 ? inputRef : null}
                                                value={entry.name}
                                                placeholder="Enter designation name"
                                                onChange={(e) => {
                                                    const updated = [...designationEntries];
                                                    updated[index].name = e.target.value;
                                                    setDesignationEntries(updated);
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        handleAddDesignation();
                                                    }
                                                }}
                                                className="
                                            designation-name-input
                                            w-full
                                            border
                                            border-gray-300
                                            rounded
                                            px-3
                                            py-2
                                            pr-12
                                            focus:outline-none
                                            focus:border-gray-300
                                             "
                                            />

                                            {/* Show delete icon on ALL inputs only when more than one exists */}
                                            {designationEntries.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => handleDeleteDesignation(index)}
                                                    className="
                                                  absolute
                                                  right-3
                                                  top-1/2
                                                 -translate-y-1/2
                                                  flex
                                                  items-center
                                                  justify-center
                                                  cursor-pointer
                                                  bg-transparent
                                                  border-none
                                                  p-0
                                                  "
                                                >
                                                    <img
                                                        src={DeleteIcon}
                                                        alt="Delete"
                                                        className="w-[20px] h-[20px] object-contain"
                                                    />
                                                </button>
                                            )}
                                        </div>
                                    ))}

                                    <div className="flex justify-end gap-3 mt-4">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (designationEntries.length < 10) {
                                                    handleAddNewField();
                                                } else {
                                                    message.warning("You cannot add more than 10 designations.");
                                                }
                                            }}
                                            className="add-new-btn"
                                        >
                                            Add New
                                        </button>
                                        <button
                                            onClick={handleCancel}
                                            className="px-6 py-2 rounded-[6px]  border border-[#393939] text-gray-700 font-semibold "
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleAddDesignation}
                                            className="px-6 py-2 rounded-[6px] bg-[#AD0101] text-white font-semibold"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        <br />
                        <GenderConfiguration roleId={roleId} accountId={accountId} />
                        <br />
                        <EmployementTypeConfiguration roleId={roleId} accountId={accountId} />
                        <br />
                        <ThresholdsConfiguration onSaveSuccess={handleNextToProductConfiguration} />
                    </>
                )}

                {activeTab === "user-management" && (
                    <UserManagement roleId={roleId} accountId={accountId} name={name} accountName={accountName}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab} />
                )}

                {activeTab === "attendance-daily-norm" && (
                    <AttendanceDailyNorm
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />
                )}

                {activeTab === "holidays" && (
                    <MarkHoliday
                        activeTab={activeTab}
                        setActiveTab={setActiveTab} />
                )}
            </div>
        </div>
        // </div>
    );
};

export default MastersConfiguration;